import { useTranslation } from "react-i18next";
import { useTheme } from "../theme/ThemeProvider";
import type { ThemeMode } from "../theme/ThemeProvider";
import styles from "./ThemeToggle.module.css";

const ICONS: Record<ThemeMode, JSX.Element> = {
  light: (
    <svg viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.4" />
      <path
        d="M8 1.2v1.6M8 13.2v1.6M14.8 8h-1.6M2.8 8H1.2M12.7 3.3l-1.1 1.1M4.4 11.6l-1.1 1.1M12.7 12.7l-1.1-1.1M4.4 4.4 3.3 3.3"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  ),
  dark: (
    <svg viewBox="0 0 16 16" fill="none">
      <path
        d="M13.5 9.8A5.6 5.6 0 0 1 6.2 2.5a5.7 5.7 0 1 0 7.3 7.3Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
    </svg>
  ),
  system: (
    <svg viewBox="0 0 16 16" fill="none">
      <rect x="1.5" y="2.8" width="13" height="8.4" rx="1.4" stroke="currentColor" strokeWidth="1.4" />
      <path d="M5.5 14h5M8 11.2V14" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  ),
};

const MODES: ThemeMode[] = ["light", "dark", "system"];

export default function ThemeToggle() {
  const { mode, setMode } = useTheme();
  const { t } = useTranslation();

  return (
    <div className={styles.group} role="radiogroup" aria-label={t("theme.ariaLabel")}>
      {MODES.map((m) => (
        <button
          key={m}
          type="button"
          role="radio"
          aria-checked={mode === m}
          title={t(`theme.${m}`)}
          className={`${styles.option} ${mode === m ? styles.optionActive : ""}`}
          onClick={() => setMode(m)}
        >
          {ICONS[m]}
        </button>
      ))}
    </div>
  );
}
